import * as React from 'react';
import {Helmet} from 'react-helmet';

import {MainHeader} from './main-header';
// @ts-expect-error
import signupData from './signup';
import {SignupImage} from './signup-image';

import styles from './new-pre-auth-layout.module.css';

export type SignupData = {
    title: string;
    reviewSectionTitle: string;
};

type Props = {
    form: React.ReactNode;
    isFullScreenForm?: boolean;
};

export function NewPreAuthLayout(props: Props) {
    const data: SignupData = signupData;

    return (
        <div className={styles['grid-container']}>
            <Helmet>
                <meta name='viewport' content='width=device-width,initial-scale=1' />
            </Helmet>
            <div className={props.isFullScreenForm ? '' : styles['grid']}>
                {!props.isFullScreenForm && (
                    <>
                        <div className={styles['main-header']}>
                            <MainHeader />
                        </div>
                        <div className={styles['left-content']}>
                            <div className={styles['header']}>{data.title}</div>
                            <div className={styles['image-container']}>
                                <SignupImage />
                            </div>
                        </div>
                    </>
                )}
                <div key='form' className={props.isFullScreenForm ? '' : styles['form']}>
                    {props.form}
                </div>
            </div>
        </div>
    );
}
